import React, { Dispatch } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router';
import { Action } from 'redux';

import { RootState } from '../../../lib/store';
import { logout } from '../../../lib/store/common-actions';
import { activateDemoAccount } from '../../../lib/store/crm';
import { hasValidCookie } from '../../../lib/store/selectors';

import ErrorLayout from '../ErrorLayout';

const DemoAccountActivationError = (props: ReduxProps): JSX.Element => {
  const navigate = useNavigate();
  const { isAppLoaded, isCookieValid, activateAccount, appLogOut } = props;

  const handleSubmit = () => {
    if (!isAppLoaded) {
      return;
    }

    if (!isCookieValid) {
      appLogOut();
      return;
    }

    activateAccount();
  };

  return (
    <ErrorLayout
      handleClose={() => {
        navigate(-1);
      }}
      handleSubmit={handleSubmit}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isAppLoaded: state.app.loaded,
  isCookieValid: hasValidCookie(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  activateAccount: () => dispatch(activateDemoAccount()),
  appLogOut: () => dispatch(logout()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DemoAccountActivationError);
